import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Tracks SPA route changes as GA4 page_view events via GTM dataLayer
const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);
};

export default usePageTracking;
